import React, { useState } from 'react';
import { CouponFieldProps } from '../../types';
import './CouponField.css';

const CouponField: React.FC<CouponFieldProps> = ({
  value,
  onChange,
  onApply,
  onRemove,
  loading = false,
  error,
  appliedCoupon,
  className = ''
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (value.trim() && !loading) {
      onApply(value.trim());
    }
  };

  const handleRemove = () => {
    onRemove();
    setIsExpanded(false);
  };

  const handleToggle = () => {
    if (appliedCoupon) {
      handleRemove();
    } else {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <div className={`coupon-field ${className}`}>
      {appliedCoupon ? (
        <div className="coupon-field__applied">
          <div className="coupon-field__applied-info">
            <div className="coupon-field__applied-code">
              <span className="coupon-field__code-label">Coupon Applied:</span>
              <span className="coupon-field__code-value">{appliedCoupon.code}</span>
            </div>
            <div className="coupon-field__applied-details">
              <span className="coupon-field__discount">
                {appliedCoupon.discountType === 'percentage' 
                  ? `${appliedCoupon.discountValue}% off`
                  : `€${(appliedCoupon.discountValue / 100).toFixed(2)} off`
                }
              </span>
              {appliedCoupon.name && (
                <span className="coupon-field__name">{appliedCoupon.name}</span>
              )}
            </div>
          </div>
          <button
            type="button"
            className="coupon-field__remove"
            onClick={handleRemove}
            disabled={loading}
            aria-label="Remove coupon"
          >
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      ) : (
        <div className="coupon-field__input-section">
          <button
            type="button"
            className="coupon-field__toggle"
            onClick={handleToggle}
            disabled={loading}
          >
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>Have a coupon code?</span>
          </button>

          {isExpanded && (
            <form className="coupon-field__form" onSubmit={handleSubmit}>
              <div className="coupon-field__input-group">
                <input
                  type="text"
                  value={value}
                  onChange={(e) => onChange(e.target.value)}
                  placeholder="Enter coupon code"
                  className="coupon-field__input"
                  disabled={loading}
                  autoFocus
                />
                <button
                  type="submit"
                  className="coupon-field__apply"
                  disabled={!value.trim() || loading}
                >
                  {loading ? (
                    <div className="coupon-field__spinner">
                      <div className="coupon-field__spinner-circle"></div>
                    </div>
                  ) : (
                    'Apply'
                  )}
                </button>
              </div>
              
            </form>
          )}
        </div>
      )}
    </div>
  );
};

export default CouponField;
